export const IS_LOADING_SAVE = "IS_LOADING_SAVE";
export const GET_OFFER_REQUESTS = "GET_OFFER_REQUESTS";
export const GET_OFFER_REQUEST_BY_ID = "GET_OFFER_REQUEST_BY_ID";
